import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { TimeslotId } from "@core/features/timeslots";

export type Args = {
  programId: number;
  onSuccess?: () => void;
};

export function useSubmitSchedulingAvailability({ programId, onSuccess }: Args) {
  return useMutation({
    mutationFn: async (data: TimeslotId[]) => {
      const payload = {
        program_id: programId,
        time_slots: data,
      };

      return await apiRequest(
        `/scheduling/availability/`,
        "POST",
        payload
      );
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
}

export default useSubmitSchedulingAvailability;

